import AccessImport from '../pages/Access';

import { integrationTypes } from '../static/constants';

export enum Pages {
    Access,
    Connected,
    Wizard,
    Settings,
    Setup,
    Organisation,
    Validator,
    Loader
}

const customConnectionMap = new Map();
customConnectionMap.set(Pages.Access, AccessImport);

const routeMapMap = new Map();
routeMapMap.set(integrationTypes.CUSTOM, customConnectionMap);

export default routeMapMap;
